import React from 'react';
import {
  LocalizationProvider,
  MobileDatePicker,
} from '@mui/x-date-pickers-pro';
import AdapterJalali from '@date-io/date-fns-jalali';
import { TextField } from '@mui/material';
import { SubstractOneMonth } from 'utils/SubstractOneMonth';
import moment from 'moment-jalaali';
import { ExcludeTenDays } from 'utils/ExcludeTenDays';
import { useTranslation } from 'react-i18next';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import styles from '../styles/date.range.styles.module.scss';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

const FromDatePicker = ({
  ExcludeOneMonth,
  GetJalaliValue,
  type,
  disabled,
  errors,
  name,
  initialValue,
  ExcludeTenDay,
  isSmall = true,
  disableFromDate,
  LockToday, // New prop
}) => {
  const [UiValue, setUiValue] = React.useState(
    ExcludeOneMonth
      ? SubstractOneMonth()
      : ExcludeTenDay
      ? ExcludeTenDays()
      : new Date()
  );

  React.useEffect(() => {
    GetJalaliValue &&
      GetJalaliValue((prev) => ({
        ...prev,
        FromDate: new Intl.DateTimeFormat(
          'fa-u-ca-persian-nu-latn',
          {
            dateStyle: 'short',
          }
        ).format(UiValue),
      }));
  }, []);

  React.useMemo(() => {
    if (initialValue) {
      setUiValue(
        moment(initialValue, 'jYYYY/jM/jD').toDate()
      );
    }
  }, [JSON.stringify(initialValue)]);

  const { t, i18n } = useTranslation();

  const done_msg = FindLangKey(
    'general-public-label-approve'
  );
  const cancel_msg = FindLangKey(
    'general-public-label-dismiss'
  );

  // Get today's date at midnight
  const today = React.useMemo(() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  }, []);

  console.log('today--->', today);

  return (
    <React.Fragment>
      <LocalizationProvider
        dateAdapter={
          i18n?.language === 'en'
            ? AdapterMoment
            : AdapterJalali
        }
        {...(i18n?.language === 'en'
          ? { adapterLocale: 'en' }
          : {})}
        localeText={{
          cancelButtonLabel: cancel_msg,
          okButtonLabel: done_msg,
        }}
      >
        <MobileDatePicker
          disabled={!!disabled || disableFromDate}
          value={UiValue}
          onChange={(newValue) => {
            setUiValue(newValue);
            GetJalaliValue &&
              GetJalaliValue((prev) => ({
                ...prev,
                FromDate: new Intl.DateTimeFormat(
                  'fa-u-ca-persian-nu-latn',
                  {
                    dateStyle: 'short',
                  }
                ).format(newValue),
              }));
          }}
          renderInput={(params) => (
            <TextField
              color="colorPrimer"
              {...params}
              fullWidth
              sx={{ marginBlock: '1em' }}
              className={styles.TextField}
              {...(isSmall && { size: 'small' })}
            />
          )}
          minDate={LockToday ? today : undefined} // Set minimum date to today if LockToday is true
          sx={{
            '& .MuiPickersArrowSwitcher-button.Mui-disabled':
              {
                color: 'red',
              },
          }}
        />
      </LocalizationProvider>
    </React.Fragment>
  );
};

export default FromDatePicker;
